import { setGetMailingStatisticsScrollerOpenGameByUserAction } from '../action';
import { getMailingStatisticsScrollerOpenGameByUser } from '../api/getMailingStatisticsScrollerOpenGameByUser';

export const setGetMailingStatisticsScrollerOpenGameByUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerOpenGameByUser(params);
            const state = getState().mailing.scrollers.open_game_by_user;

            const new_data = {
                ...state,
                [params.login]: data
            }
            dispatch(setGetMailingStatisticsScrollerOpenGameByUserAction(new_data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}